import { LinkCreationService } from '@sportal365/smp-widget-utils';
import { TARGET_BLANK, TARGET_SELF } from '../../../../packages/constants/windowTarget';
import { IMultisportConfigEntityLinks, IMultisportEvent, SportTypes } from '../../../../packages/types';

export const getGompetitionEventLink = (
  sport: SportTypes,
  event: IMultisportEvent,
  dataEntityLinks: IMultisportConfigEntityLinks | null | undefined,
) => {
  const link = dataEntityLinks && getLink(sport, dataEntityLinks);
  const linkService = dataEntityLinks && link && new LinkCreationService(link);

  const target = link?.configuration?.newWindow ? TARGET_BLANK : TARGET_SELF;

  const sides = event.sides;
  const firstTeam = sides?.first;
  const secondTeam = sides?.second;

  const eventIdBySport = event.sport === SportTypes.FOOTBALL ? event.legacyId : event.id;
  const eventLink = linkService?.createMatchUrl(eventIdBySport || event.id, firstTeam, secondTeam, event.slug ?? undefined) ?? '#';

  return { eventLink, urlTarget: target };
};

export const getCompetitionLink = (
  sport: SportTypes,
  competitionId: string,
  slug: string,
  dataEntityLinks: IMultisportConfigEntityLinks | null | undefined,
) => {
  const link = dataEntityLinks && getLink(sport, dataEntityLinks);
  const linkService = dataEntityLinks && link && new LinkCreationService(link);
  const target = link?.configuration?.newWindow ? TARGET_BLANK : TARGET_SELF;
  const competitionLink = linkService?.createEntityUrl(competitionId, 'competition', '', slug) ?? undefined;
  return { competitionLink, urlTarget: target };
};

const getLink = (sport: SportTypes, config: IMultisportConfigEntityLinks) => {
  switch (sport) {
    case SportTypes.FOOTBALL:
      return config.football;
    case SportTypes.BASKETBALL:
      return config.basketball;
    case SportTypes.TENNIS:
      return config.tennis;
    case SportTypes.ICE_HOCKEY:
      return config.iceHockey;
    case SportTypes.HANDBALL:
      return config.handball;
    case SportTypes.RUGBY_LEAGUE:
      return config.rugby;
    case SportTypes.CRICKET:
      return config.cricket;
    case SportTypes.ROLLER_HOCKEY:
      return config.rollerHockey;
    case SportTypes.CYCLING:
      return config.cycling;
    case SportTypes.MOTORSPORTS:
      return config.motorsports;
    default:
      return null;
  }
};
